import { render, staticRenderFns } from "./SupplierStockShippingSurchargeComponent.vue?vue&type=template&id=6772a027&"
import script from "./SupplierStockShippingSurchargeComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockShippingSurchargeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports